module.exports = __webpack_public_path__ + "static/media/02_In-Transit_Delayed.f649b9c3.jpg";